/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=35ddf27a&scoped=true"
import script from "./stat.vue?vue&type=script&lang=js"
export * from "./stat.vue?vue&type=script&lang=js"
import style0 from "./stat.vue?vue&type=style&index=0&id=35ddf27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddf27a",
  null
  
)

export default component.exports